module.exports = __webpack_public_path__ + "img/Toth.01fb2a39.jpg";